import { useState } from 'react';

// Nút đổi giao diện: lần lượt Theo máy -> Sáng -> Tối.
// "Theo máy" = xóa data-theme để CSS dùng prefers-color-scheme.
const ORDER = ['system', 'light', 'dark'];
const META = {
  system: { ico: 'ti-device-desktop', label: 'Theo máy' },
  light: { ico: 'ti-sun', label: 'Sáng' },
  dark: { ico: 'ti-moon', label: 'Tối' },
};

function currentMode() {
  const t = localStorage.getItem('ft-theme');
  return t === 'dark' || t === 'light' ? t : 'system';
}

export default function ThemeToggle() {
  const [mode, setMode] = useState(currentMode);

  function cycle() {
    const next = ORDER[(ORDER.indexOf(mode) + 1) % ORDER.length];
    setMode(next);
    if (next === 'system') {
      document.documentElement.removeAttribute('data-theme');
      localStorage.removeItem('ft-theme');
    } else {
      document.documentElement.setAttribute('data-theme', next);
      localStorage.setItem('ft-theme', next);
    }
  }

  const meta = META[mode];
  return (
    <button
      className="btn ghost sm"
      style={{ width: '100%', marginTop: 8 }}
      onClick={cycle}
      title="Đổi giao diện sáng/tối"
    >
      <i className={`ti ${meta.ico}`} aria-hidden="true" /> Giao diện: {meta.label}
    </button>
  );
}
